<template>
  <cus-order-dialog>
    <template v-slot:title>
      <div v-if="!is_detail" class="search-button">
        <cus-button
          v-if="!is_search"
          text="搜尋取餐號"
          color="blue"
          style="min-height: 45px"
          @click="openInnerDialog('searchOutsideId')"
        ></cus-button>
        <cus-button v-else text="取消搜尋" color="red" style="min-height: 45px" @click="cancelSearch"></cus-button>
      </div>
      <p class="dialog-title">掛單{{ is_detail ? '：查看訂單' : '' }}</p>
    </template>
    <template v-slot:body>
      <div class="body-wrap">
        <!--  訂單列表 -->
        <div v-if="!is_detail" class="order-list">
          <div class="source">
            <cus-radio :radioList="sourceBtns" v-model:selectValue="selectSource" :disabled="is_search"></cus-radio>
          </div>
          <order-list
            type="pending"
            :orderList="orderList"
            v-model:selectOrder="selectOrder"
            v-model:listPage="listPage"
          ></order-list>
        </div>
        <!--  查看訂單 -->
        <div v-else class="order-detail">
          <all-detail-info :orderData="orderData"></all-detail-info>
        </div>
      </div>
    </template>
    <template v-slot:footer>
      <div class="d-flex">
        <div v-if="!is_detail" class="d-flex" style="width: 50%">
          <cus-button text="關閉" color="white" :width="50" @click="close"></cus-button>
          <cus-button
            text="查看訂單"
            color="white"
            :width="50"
            :disabled="!selectOrder"
            @click="handleClickDetail"
          ></cus-button>
        </div>
        <cus-button v-else text="返回" color="white" :width="50" @click="backToList"></cus-button>
        <div v-if="checkSource()" class="d-flex" style="width: 25%">
          <cus-button
            v-if="checkSource() === 'edit'"
            text="繼續編輯"
            color="white"
            :disabled="!selectOrder"
            @click="handleRestore('order')"
          ></cus-button>
          <cus-button
            v-if="checkSource() === 'delay'"
            text="延遲"
            color="white"
            :disabled="!selectOrder || selectOrder.delay_accept_count === 2"
            @click="openInnerDialog('delay')"
          ></cus-button>
        </div>
        <cus-button
          text="結帳"
          color="blue"
          :width="checkSource() ? 25 : 50"
          :disabled="!selectOrder"
          @click="handleRestore('checkout')"
        ></cus-button>
      </div>
    </template>
  </cus-order-dialog>

  <!-- 彈窗 -->
  <component :is="inner_dialogTemplate"></component>
</template>
<script>
import { ref, inject, defineAsyncComponent, watch, getCurrentInstance } from 'vue';
import { getHangSourceButtons } from '@/utils/define';
import { useGetters, useActions } from '@/utils/mapStore';
import { useDialogInDialog } from '@/utils/dialog';
import { useRouter } from 'vue-router';
export default {
  name: 'pending-order',
  components: {
    OrderList: defineAsyncComponent(() => import('@/components/orderDialog/OrderList.vue')),
    AllDetailInfo: defineAsyncComponent(() => import('@/components/orderDialog/AllDetailInfo.vue')),
    DelayOrder: defineAsyncComponent(() => import('@/components/orderDialog/DelayOrder.vue')),
    StringNumberInput: defineAsyncComponent(() => import('@/components/dialog/StringNumberInput.vue')),
  },
  setup() {
    const { proxy } = getCurrentInstance();
    //接受provide參數
    const close = inject('order_close');
    const controlCloseButton = inject('order_controlCloseButton');
    //取得radio button清單
    const sourceBtns = getHangSourceButtons();
    const selectSource = ref(sourceBtns[0].value);
    //設定列表參數
    const selectOrder = ref(null);
    const listPage = ref(1);
    const getPageItem = useGetters('handleOrder', ['getPageItem']);
    //取得訂單列表
    const doGetPendingOrderList = useActions('handleOrder', ['doGetPendingOrderList']);
    const getPendingOrder = useGetters('handleOrder', ['getPendingOrder']);
    const orderList = ref([]);
    const getOrderList = async (source) => {
      if (source === 'all') {
        orderList.value = getPendingOrder.value;
      } else {
        orderList.value = [];
        getPendingOrder.value.forEach((e) => {
          if (e.source === source) orderList.value.push(e);
        });
      }
    };
    //監聽清單
    watch(getPendingOrder, () => {
      getOrderList(selectSource.value);
    });
    //來源切換
    watch(
      selectSource,
      async () => {
        if (selectSource.value === 'all') await doGetPendingOrderList();
        getOrderList(selectSource.value);
        selectOrder.value = null;
        listPage.value = 1;
      },
      { immediate: true }
    );
    //檢查來源(是否可以繼續編輯或延遲)
    const checkSource = () => {
      if (!selectOrder.value) {
        switch (selectSource.value) {
          case 'app':
          case 'juton':
            return 'delay';
          case 'foodpanda':
          case 'uber_eat':
            return null;
          default:
            return 'edit';
        }
      } else {
        switch (selectOrder.value.source) {
          case 'app':
          case 'juton':
            return 'delay';
          case 'foodpanda':
          case 'uber_eat':
            return null;
          default:
            return 'edit';
        }
      }
    };

    //查看訂單
    const orderData = ref(null);
    const is_detail = ref(false);
    watch(is_detail, () => {
      controlCloseButton(is_detail.value);
    });
    const doGetOrderInfo = useActions('handleOrder', ['doGetOrderInfo']);
    const handleClickDetail = async () => {
      const res = await doGetOrderInfo(selectOrder.value.order_id);
      orderData.value = res;
      is_detail.value = true;
    };
    //返回列表
    const backToList = () => {
      is_detail.value = false;
      orderData.value = null;
    };

    //繼續編輯或結帳
    const dorRestoreOrder = useActions('handleOrder', ['dorRestoreOrder']);
    const doCheckDeviceStatus = useActions('system', ['doCheckDeviceStatus']);
    const router = useRouter();
    const handleRestore = async (action) => {
      try {
        await doCheckDeviceStatus();
        await dorRestoreOrder(selectOrder.value.order_id);
        router.push(`/${action}`);
        close();
      } catch {
        handleRestore(action);
      }
    };

    //開啟彈窗
    const { inner_dialogTemplate, openInnerDialog, closeInnerDialog } = useDialogInDialog();

    //延遲訂單
    const doSetOrderDelay = useActions('handleOrder', ['doSetOrderDelay']);
    const handleDelayOrder = async (val) => {
      const data = {
        order_id: selectOrder.value.order_id,
        delay_minute: val.delay_minute.value,
        note: val.input_reason ? val.input_reason : val.select_reason,
      };
      await doSetOrderDelay(data);
      await doGetPendingOrderList();
      //更新selectOrder
      selectOrder.value = orderList.value.find((e) => e.order_id === selectOrder.value.order_id);
      listPage.value =
        Math.ceil(
          (orderList.value.findIndex((e) => e.order_id === selectOrder.value.order_id) + 1) / getPageItem.value
        ) || 1;
      //更新OrderData
      if (is_detail.value) {
        const res = await doGetOrderInfo(selectOrder.value.order_id);
        orderData.value = res;
      }
      closeInnerDialog();
    };

    //搜尋訂單
    const is_search = ref(false);
    const handleSearchOutsideId = (val) => {
      let searchList = [];
      getPendingOrder.value.forEach((e) => {
        if (e.outside_order_id.includes(val)) searchList.push(e);
      });
      if (searchList.length === 0) {
        proxy.$message('錯誤提示', `查無此訂單：${val}`).catch((e) => e);
        return;
      }
      orderList.value = searchList;
      closeInnerDialog();
      is_search.value = true;
      selectOrder.value = null;
    };
    //取消搜尋
    const cancelSearch = () => {
      getOrderList(selectSource.value);
      is_search.value = false;
      selectOrder.value = null;
    };
    return {
      close,
      sourceBtns,
      selectSource,
      selectOrder,
      listPage,
      orderList,
      checkSource,
      orderData,
      is_detail,
      handleClickDetail,
      backToList,
      handleRestore,
      inner_dialogTemplate,
      openInnerDialog,
      handleDelayOrder,
      is_search,
      handleSearchOutsideId,
      cancelSearch,
    };
  },
};
</script>
<style lang="scss" scoped>
.dialog-title {
  text-align: center;
  font-size: 2.4rem;
  line-height: 60px;
  color: $color-blue;
}
.search-button {
  width: 140px;
  position: absolute;
  top: 16px;
  left: 16px;
}
.body-wrap {
  position: relative;
  padding: 0 4px;
}
.order-list {
  height: 100%;
  display: grid;
  grid-template-rows: 12% auto;
  .source {
    width: 75%;
    margin: 0 auto;
    @include flex-center-center;
  }
}
.order-detail {
  width: 100%;
  height: 100%;
  background-color: #fff;
}
</style>
